import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { video_kv_sources } from '@/constants/whole-home';

export default function A() {
    const { useLang, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('wholehome');
    const { locale } = useRouter();
    const [showVideo, setShowVideo] = useState(false);

    const handlePlay = () => {
        setShowVideo(true);
        gtm?.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'WHOLE-HOME BACKUP POWER SOLUTION',
            position: 'Product Detail_1',
        });
    };

    return (
        <div className={`whole-home-A ${css['whole-home-A']}`}>
            <div className="img-box">
                <NextImage
                    // webpSrc={require('@publicLocal/whole-home/pc/1.jpg')}
                    src={require('@publicLocal/whole-home/pc/1.jpg')}
                    alt={t('secA_title')}
                    aria-label={t('secA_title')}
                    priority={true}
                />
            </div>
            <div className="text-wrapper">
                <p className="title">{t('secA_title')}</p>
                <p className="subtitle">{t('secA_subtitle')}</p>
            </div>
            <div className="video-link" onClick={handlePlay}>
                <span className="video-text">{t('secA_video')}</span>
                <svg className="video-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path
                        d="M9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75Z"
                        stroke="#2673FF"
                        strokeWidth="1.5"
                    />
                    <path
                        d="M7.05657 4.90909C6.77427 4.90909 6.54541 5.13794 6.54541 5.42025V12.5797C6.54541 12.674 6.57151 12.7665 6.62081 12.8469C6.76839 13.0875 7.08312 13.163 7.32378 13.0154L13.1615 9.43572C13.2301 9.39361 13.2879 9.33585 13.33 9.26717C13.4776 9.02651 13.4021 8.71178 13.1615 8.5642L7.32378 4.98449C7.24338 4.93519 7.15089 4.90909 7.05657 4.90909Z"
                        fill="#2673FF"
                    />
                </svg>
            </div>
            <div className="card-box">
                <p className="card-title">{t('secA_card_title')}</p>
                <p className="card-text">{t('secA_card_text')}</p>
                <a className="card-btn" href="#whole-home-D">
                    {t('secA_card_btn')}
                </a>
            </div>
            <EFVideoModal
                visible={showVideo}
                source={video_kv_sources[locale] || video_kv_sources.us}
                onClose={() => setShowVideo(false)}
                playerType={'YouTube'}
            />
        </div>
    );
}
